import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import styles from "./HomePage.module.css";
import logo from "../../assets/icons/qvh-logo.svg";

export default function HomePage() {
  const navigate = useNavigate();
  const { logoutUser } = useAuth();

  const handleLogout = () => {
    logoutUser();
    navigate("/", { replace: true });
  };

  return (
    <div className={styles["dashboard"]}>
      <aside className={styles["sidebar"]}>
        <nav className={styles["sidebar-nav"]}>
          <button
            className={styles["nav-item"]}
            onClick={() => navigate("/diabetesBefundForm")}
          >
            <span className={styles["nav-label"]}>Rezeptvorschlag</span>
            <span className={styles["nav-sub"]}>für Ärzte</span>
          </button>
          <button
            className={styles["nav-item"]}
            onClick={() => navigate("/patientenliste")}
          >
            <span className={styles["nav-label"]}>Move Control Diab</span>
            <span className={styles["nav-sub"]}>Diabetes Befundbogen</span>
          </button>
          <button
            className={styles["nav-item"]}
            onClick={() => navigate("/orthotimer")}
          >
            <span className={styles["nav-label"]}>Orthotimer</span>
            <span className={styles["nav-sub"]}>Daten</span>
          </button>
          <button
            className={styles["nav-item"]}
            onClick={() => navigate("/mos-patienten")}
          >
            <span className={styles["nav-label"]}>MOS Patienten</span>
            <span className={styles["nav-sub"]}>Alle Fragebogen</span>
          </button>
          <button
            className={styles["nav-item"]}
            onClick={() => navigate("/mos-links")}
          >
            <span className={styles["nav-label"]}>MOS-Links</span>
            <span className={styles["nav-sub"]}>Generieren &amp; verwalten</span>
          </button>
          <button
            className={styles["nav-item"]}
            onClick={() => navigate("/mos-dashboard")}
          >
            <span className={styles["nav-label"]}>MOS Dashboard</span>
            <span className={styles["nav-sub"]}>Auswertung &amp; Übersicht</span>
          </button>
          <button
            className={styles["nav-item"]}
            onClick={() => navigate("/osse-dashboard")}
          >
            <span className={styles["nav-label"]}>OSSE Dashboard</span>
            <span className={styles["nav-sub"]}>Auswertung &amp; Übersicht</span>
          </button>
        </nav>
        <div className={styles["sidebar-footer"]}>
          <button className={styles["logout-btn"]} onClick={handleLogout}>
            Abmelden
          </button>
        </div>
      </aside>

      <main className={styles["dashboard-content"]}>
        <img src={logo} alt="IETEC Logo" className={styles["dashboard-logo"]} />
      </main>
    </div>
  );
}
